import { useEffect } from 'react';

const DEFAULT_TITLE = 'Adhva Academy | UPSC, KPSC & PSI Preparation';
const DEFAULT_DESCRIPTION = 'Adhva Academy offers mentorship, test series and learning paths for UPSC, KPSC KAS, PSI and other competitive exams.';

/** Updates document metadata for this client-rendered page. */
const PageMetadata = ({ title = DEFAULT_TITLE, description = DEFAULT_DESCRIPTION, noIndex = false }) => {
  useEffect(() => {
    document.title = title;

    let descriptionTag = document.querySelector('meta[name="description"]');
    if (!descriptionTag) {
      descriptionTag = document.createElement('meta');
      descriptionTag.name = 'description';
      document.head.appendChild(descriptionTag);
    }
    descriptionTag.content = description;

    let robotsTag = document.querySelector('meta[name="robots"]');
    if (!robotsTag) {
      robotsTag = document.createElement('meta');
      robotsTag.name = 'robots';
      document.head.appendChild(robotsTag);
    }
    robotsTag.content = noIndex ? 'noindex, nofollow' : 'index, follow';
  }, [title, description, noIndex]);

  return null;
};

export default PageMetadata;
